// this module is only for web
import React from 'react';
import { View } from 'react-native';

import * as TextC from "./_ccbTextC";
import * as _cmFLI from "./_cmFLI";
import * as _cr from "./_cr";
import * as _hm from "./_hm";
import * as _ht from "./_ht";

import Dzn from 'react-dropzone'; // only for web

import { useMdlz } from "./_csMdl";
import { a } from "./_cmABT";

export const useFilez = () => {

  const _sMdlz = useMdlz();

  const _show = (pz: {
    mode?: 't' | 'c',
    onRead: (_dz: _ht.dz) => void,
  }) => {

    const _ls = [
      _cr.c(Dzn, {
        onDrop: (_files: _ht.ls) => {
          _sMdlz.hide();
          _files.map( async (_file: _ht.o) => {
            const _dz = await _cmFLI.iptAsync({
              mode: pz.mode,
              file: _file
            }) as _ht.dz;
            pz.onRead(_dz);
          });
        },
        multiple: true,
      }, 
        (_dz: _ht.dz) => {
          return (
            _cr.c('div', {
              ... _dz.getRootProps(),
              style: a(`dw/40 dh/40 fd/ccc sc/lt1`),
            }, [

              _cr.c('input', {
                key: -10,
                ... _dz.getInputProps()
              }),

              _cr.c(TextC.N, {
                key: -20,
                boxStlz: a(`bc/lt5 br/1 bs/ds bw/1 dw/38 dh/38 fd/ccc m/1`),
                text: 'ここにファイルを置いてください',
                textStlz: a(`tc/lt9`),
              })
            ]
            )
          );
        }
      ),
    ];


    _sMdlz.set({
      bShow: true,
      mdlClds: _ls,
    })

  }

  return {
    show: _show
  }

};
